import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import type { ReactElement } from 'react';
import { UserRole } from '@asko/shared';
import { AuthProvider, useAuth } from './lib/auth';
import { I18nProvider, useI18n } from './lib/i18n';
import { LoginPage } from './pages/LoginPage';
import { FlowPage } from './pages/FlowPage';
import { MobileCapturePage } from './pages/MobileCapturePage';
import { MyIdCallbackPage } from './pages/MyIdCallbackPage';
import { HistoryPage } from './pages/HistoryPage';
import { UsersPage } from './pages/UsersPage';

/** Faqat tizimga kirgan foydalanuvchi ko'ra oladigan sahifa. */
function Protected({ children }: { children: ReactElement }) {
  const { user, loading } = useAuth();
  const { t } = useI18n();

  if (loading) {
    return (
      <div className="center-screen">
        <div className="spinner" aria-label={t('common.loading')} />
      </div>
    );
  }

  return user ? children : <Navigate to="/login" replace />;
}

/**
 * Faqat ma'muriyat uchun. Sotuvchi manzilni qo'lda tersa ham o'z
 * ekraniga qaytadi — server baribir rad etadi, lekin bo'sh sahifa
 * ko'rsatishning ma'nosi yo'q.
 */
function AdminOnly({ children }: { children: ReactElement }) {
  const { user } = useAuth();
  return user?.role === UserRole.ADMIN ? children : <Navigate to="/" replace />;
}

export function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            {/*
              Mijozning telefoni uchun (QR). Kirish talab qilinmaydi —
              himoya havoladagi tokenda (`handoff.store.ts`).
            */}
            {/* MyID mijozni shu manzilga qaytaradi — u MyID'da ro'yxatdan o'tgan */}
            <Route path="/m/myid/callback" element={<MyIdCallbackPage />} />
            <Route path="/m/:token" element={<MobileCapturePage />} />
            <Route
              path="/"
              element={
                <Protected>
                  <FlowPage />
                </Protected>
              }
            />
            <Route
              path="/tarix"
              element={
                <Protected>
                  <AdminOnly>
                    <HistoryPage />
                  </AdminOnly>
                </Protected>
              }
            />
            <Route
              path="/foydalanuvchilar"
              element={
                <Protected>
                  <AdminOnly>
                    <UsersPage />
                  </AdminOnly>
                </Protected>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
